import { ref } from '@vue/composition-api';
import Candidate from '@/orm/models/Candidate/Candidate';

const currentPage = ref(1);
const hasMoreData = ref(true);
const isLoadingNextPage = ref(false);
const currentSearch = ref('');

export default function useKanbanPagination() {
  function reset(search = '') {
    currentPage.value = 1;
    hasMoreData.value = true;
    isLoadingNextPage.value = false;
    currentSearch.value = search;
  }

  function incrementPage() {
    currentPage.value += 1;
  }
  async function prefetchNextPage(vacancyId) {
    if (isLoadingNextPage.value || !hasMoreData.value) return false;
    isLoadingNextPage.value = true;
    try {
      const nextPage = currentPage.value + 1;
      const response = await Candidate.api().fetchPaginatedCandidates(vacancyId, {
        page: nextPage,
        perPage: 20,
        search: currentSearch.value,
      });
      const data = response?.response?.data;
      const hasData = Array.isArray(data?.data)
        ? data.data.length > 0
        : Array.isArray(data) && data.length > 0;
      currentPage.value = nextPage;
      hasMoreData.value = hasData;
      return hasData;
    } catch {
      return false;
    } finally {
      isLoadingNextPage.value = false;
    }
  }

  return {
    currentPage,
    hasMoreData,
    isLoadingNextPage,
    currentSearch,
    reset,
    incrementPage,
    prefetchNextPage,
  };
}
